// import { toast } from "react-toastify";

import toast from "react-hot-toast";
import Cookies from "js-cookie";
import MainRoutes from "../Navigation/MainRoutes";
import { clearReduxState } from '../Helpers/clearReduxState';

export const resolveErrorMessage = async (error) => {
  console.log("error?.response?.status", error?.response?.status);
  let message = "";
  console.log({ error });
  if (typeof error == "string") {
    message = error;
  } else if (typeof error.response?.data === "string") {
    message = error.response.data;
  } else if (typeof error.response?.data.message === "string") {
    console.log(error.response.data.message);
    message = error.response.data.message;
  } else {
    message = error.message;
  }
  if (error?.response?.status === 401 || error?.response?.status === 426) {
    toast.loading("Checking Session please wait...");
    await clearReduxState();
    Cookies.remove("isLoggedIn");
    window.location.href = MainRoutes.HOME;
    localStorage.clear();
  }
  return message;
};

